import React, { PureComponent } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Icon } from 'semantic-ui-react';
import Tooltip from 'material-ui/Tooltip';
import { LicenseEditModal } from 'components';

import classNames from 'classnames/bind';
import styles from './AdminLicenseInTableMenu.css';
const cx = classNames.bind(styles);

class AdminLicenseInTableMenu extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      deleteModal: false,
      editModal: false
    };
  }

  mountDeleteModal = () => {
    this.setState({ deleteModal: !this.state.deleteModal });
  };

  mountEditModal = () => {
    this.setState({ editModal: !this.state.editModal });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { editModal } = this.state;
    const { isAuth, licenseInfo } = this.props;
    const { mountEditModal } = this;

    return (
      <div className={cx('inline-conf-area', 'item1')}>
        {licenseInfo.status === -1 ? (
          <Tooltip
            title={defineMessages(formatMessage({ id: 'AdminLicenseInTableMenu_1', defaultMessage: '라이센스 발급' }))}
            placement="bottom">
            <Icon color="grey" className={cx('icon-add')} name="add square" link onClick={mountEditModal} />
          </Tooltip>
        ) : (
          <Tooltip
            title={defineMessages(formatMessage({ id: 'AdminLicenseInTableMenu_2', defaultMessage: '라이센스 수정' }))}
            placement="bottom">
            <Icon color="grey" className={cx('icon-edit')} name="edit" link onClick={mountEditModal} />
          </Tooltip>
        )}
        {editModal && (
          <LicenseEditModal
            isAuth={isAuth}
            licenseInfo={licenseInfo}
            mountEditModal={mountEditModal}
            actionMode={licenseInfo.status === -1 ? 'default' : 'edit'}
          />
        )}
      </div>
    );
  }
}

export default injectIntl(AdminLicenseInTableMenu);



// WEBPACK FOOTER //
// ./src/script/components/admin/license/AdminLicenseInTableMenu.js